<template lang="pug">
  .changelog
    section
      .max-width
        .breadcrumbs(v-if="isApp")
          ul
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminDashboard' : 'PublicDashboard'}") Dashboard
            li
              span \
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminChangelog' : 'PublicChangelog'}") Changelogs
            li
              span \
            li
              span {{ changelog.title }}

    section
      .max-width
        .row.apart
          .col.max
            header.changelog-header
              .tabs
                .row.apart
                  .col
                    .tab.active
                      h2 {{ changelog.title }}


            .changelog-description
              div(v-html="changelog.description")

            .features
                  BoardFeature(v-for="feature in changelog.features", :feature="feature.feature", :key="feature.feature._id", type="changelog")

          .col
            aside
              .member(v-if="company.isMember && isAdmin")
                p hello

</template>

<script>

import { mapState } from 'vuex'
import BoardFeature from '@/components/BoardFeature'

export default {
  name: 'ChangelogDetail',
  components: {
    BoardFeature
  },
  data () {
    return {
    }
  },
  beforeMount () {
    console.log('changelog detail')
    this.getChangelog()
  },
  computed: {
    ...mapState({
      company: state => state.company,
      changelog: state => state.changelogs.selected
    }),
    isAdmin () {
      return this.$route.matched[0].meta.member
    },
    isApp () {
      //console.log(this.$route)
      return !(this.$route.meta && this.$route.meta.widget)
    }
  },
  methods: {
    getChangelog () {
      this.$store.dispatch('changelogs/getChangelog', this.$route.params.changelogSlug)
    }
  },
  watch: {
  }
}

</script>

<style lang="stylus" scoped>
.changelog-description
  padding $spacing-2 0
aside
  border $border-default
  border-radius $border-radius
  margin-left $spacing-3
  width 370px
  .member
    padding $spacing-3

</style>
